import * as utils from './bellplus-utils';
import axios from 'axios';
import { ENV } from '../constants/Constants';
import { logoutApp } from '../services/logout.service';
import { logException } from './exception';
import store from '../store/storeConfig';
import { setProgress } from 'store/actions/progressActions';
import { SET_PROGRESS } from 'Stores/Slices/progressSlice';

const serverErrorMessage = 'There is some server error. Please try after sometime!';
export const login = async (url: any, obj: any) => {
	return new Promise(function (resolve, reject) {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			.post(url, obj)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 500) {
					logException('POST', url, obj, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const forgotPassword = async (url: any, obj: any) => {
	return new Promise(function (resolve, reject) {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			.post(url, obj)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response) {
					if (response.errors && response.errors.length) {
						errorMessage = response.errors[0];
					}
					if (response && response.data) {
						if (response.data.errors && response.data.errors.length) {
							errorMessage = response.data.errors[0];
						}
					}
				}
				store.dispatch(SET_PROGRESS(false));
				if (err?.response?.status === 500) {
					logException('POST', url, obj, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const businessCategory = async (url: any) => {
	return new Promise(function (resolve, reject) {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			.get(url)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				if (err?.response?.status === 401) {
					logoutApp();
				}
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				store.dispatch(SET_PROGRESS(false));
				if (err?.response?.status === 500) {
					logException('GET', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const postapiresponses = async (url: any, obj: any) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.post(url, obj)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;
				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('POST', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};
export const putapiresponses = async (url: any, obj: any, logout: any = true) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.put(url, obj)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401 && logout) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('PUT', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const getapiresponses = async (url: any) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.get(url)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('GET', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const deleteapiresponses = async (url: any) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.delete(url)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('DELETE', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const uploadapiresponses = async (url: any, obj: any, config: any) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		axios
			.create({
				baseURL: ENV.dev.globalUrl,
				headers: headers,
			})
			.post(url, obj, config)
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('POST', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}
			});
	});
};

export const deleteapiDataresponses = async (url: any, obj: any) => {
	const headers = await utils.getHeaders();
	return new Promise((resolve, reject) => {
		const URL = ENV.dev.globalUrl + url;
		axios({
			method: 'delete',
			url: URL,
			data: obj,
			headers: headers,
		})
			.then((response) => {
				return resolve(response);
			})
			.catch((err) => {
				let response: any = {};
				response = err.response;

				let errorMessage: any = '';
				if (response && response.data) {
					if (response.data.errors && response.data.errors.length) {
						errorMessage = response.data.errors[0];
					}
				}
				if (err?.response?.status === 401) {
					store.dispatch(SET_PROGRESS(false));
					logoutApp();
				} else if (err?.response?.status === 500) {
					logException('DELETE', url, {}, errorMessage);
					return reject(serverErrorMessage);
				} else {
					return reject(errorMessage);
				}

				return reject(errorMessage);
			});
	});
};
